import { Box, BoxProps } from '@material-ui/core';
import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    '& > div:first-child': {
      width: '100%',
      padding: theme.spacing(6, 0),
      paddingLeft: '13vw',
      paddingRight: '13vw',
      '@media(max-width: 768px)': {
        paddingLeft: '8vw',
        paddingRight: '8vw',
      },
    },
  },
}));

const CenteredPage = (props: PropsWithChildren<BoxProps>) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Box width={'100%'} {...{ ...props, children: undefined }}>
          {props.children}
        </Box>
      </div>
    </div>
  );
};

export default CenteredPage;
